import React, { FC, Dispatch, SetStateAction } from "react";
import DealerCells from "./Cells/DealerCells";
import AdminInsideSalesCells from "./Cells/AdminInsideSalesCells";
import OutsideSalesCells from "./Cells/OutsideSalesCells";
import ProductionCells from "./Cells/ProductionCells";
import { QuoteObj, Overwrite, UserObj } from "../../../GlobalTypes";
import dealerRoles from "../../../util/dealerAccounts";

type AdminQuoteObj = Overwrite<QuoteObj, { userId: UserObj }>;

interface QuoteFetchTableAdmin extends AdminQuoteObj {
  daysToClose?: string;
}

interface QuoteFetchTable extends QuoteObj {
  daysToClose?: string;
}

export interface TableCellsProps {
  tab: string;
  row: QuoteFetchTable | QuoteFetchTableAdmin;
  handleViewClick?: (quote: QuoteObj) => void;
  numSelected?: number;
  hoverId?: string;
  handleCheck: (event: React.MouseEvent<any>, quote: QuoteObj) => void;
  isItemSelected: boolean;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  displayLeadNumberCells?: boolean
}

interface RoleTableCellsProps extends TableCellsProps {
  role: string;
}

const RoleTableCells: FC<RoleTableCellsProps> = ({
  role,
  tab,
  row,
  handleViewClick,
  loading,
  isItemSelected,
  handleCheck,
  numSelected,
  hoverId,
  setLoading,
  displayLeadNumberCells
}) => {
  if (dealerRoles.includes(role))
    return (
      <DealerCells
        row={row as QuoteFetchTable}
        handleViewClick={handleViewClick}
        tab={tab}
        role={role}
        handleCheck={handleCheck}
        isItemSelected={isItemSelected}
        numSelected={numSelected}
        hoverId={hoverId}
        loading={false}
        setLoading={setLoading}
      />
    );

  if (role === "Admin" || role === "Inside Sales")
    return (
      <AdminInsideSalesCells
        row={row as QuoteFetchTableAdmin}
        handleViewClick={handleViewClick}
        loading={loading}
        tab={tab}
        isItemSelected={isItemSelected}
        handleCheck={handleCheck}
        numSelected={numSelected}
        hoverId={hoverId}
        setLoading={setLoading}
        displayLeadNumberCells={displayLeadNumberCells}
      />
    );

  if (role === "Outside Sales")
    return (
      <OutsideSalesCells
        row={row as QuoteFetchTableAdmin}
        handleViewClick={handleViewClick}
        tab={tab}
        handleCheck={handleCheck}
        isItemSelected={isItemSelected}
        numSelected={numSelected}
        hoverId={hoverId}
        loading={loading}
        setLoading={setLoading}
        displayLeadNumberCells={displayLeadNumberCells}
      />
    );

  if (role === "Production")
    return (
      <ProductionCells
        row={row as QuoteFetchTableAdmin}
        loading={loading}
        tab={tab}
        isItemSelected={isItemSelected}
        handleCheck={handleCheck}
        setLoading={setLoading}
      />
    );

  return null;
};

export default RoleTableCells;
